<div>
    <iframe [src]='getYoutubeEmbeddedURL()' frameborder="0" allowfullscreen class="youtube-iframe"></iframe>
    <div class="video-title">
        {{ productVideo?.title }}
    </div>
    <div class="video-description" [innerHTML]="productVideo?.description">
    </div>
    <div class="video-close-button-container">
        <button nz-button nzType="default" (click)="close()">
            <span>Close</span>
        </button>
    </div>
</div>
